import { styled } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import LoaderGlobal from "../molecules/LoaderGlobal";

type Props = {
  type?: "submit" | "reset" | "button" | undefined;
  children: React.ReactNode;
  className: string;
  style?: any;
  onClick?: () => void;
  disabled?: boolean;
  stylingType?: "events_styling" | "booking_proposal_styling";
};

const Button = ({
  type,
  children,
  className,
  style,
  onClick,
  disabled,
  stylingType = "events_styling",
}: Props) => {
  const { generalSettings } = useSelector(
    (state: RootState) => state.generalSettings,
  );

  if (Object.keys(generalSettings).length === 0) {
    return <LoaderGlobal />;
  }

  const StyledButton = styled("button")(({ theme }) => ({
    cursor: "pointer",
    color: generalSettings[stylingType].buttonTextColor,
    backgroundColor: generalSettings[stylingType].buttonBackgroundColor,
    border: "none",
    borderRadius: "0.5em",

    "&:hover": {
      color: generalSettings[stylingType].buttonHoverTextColor,
      backgroundColor: generalSettings[stylingType].buttonHoverBackgroundColor,
      "&:disabled": {
        color: "#fff",
        backgroundColor: "rgb(156 163 175)",
        cursor: "not-allowed",
      },
    },
  }));

  return (
    <StyledButton
      type={type}
      className={className}
      style={style}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
